import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-security-page',
    templateUrl: './security-page.component.html',
    styleUrls: ['./security-page.component.css'],
    standalone: false
})
export class SecurityPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
